import styled from 'styled-components/macro';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const DescriptionWrapper = styled.div `
  padding: 16px 0;

  ${ADAPTIVE.minWidth.tablet} {
    padding: 0px;
    margin-top: 8px;
  }
`;
export const DescriptionStyled = styled.div `
  & > p,
  & > * {
    ${getTextStyles('Ubuntu', 400, 16, 24)}

    color: ${colorCoreWhite1000};

    word-break: break-word;
  }

  & > p {
    margin: 8px 0;
  }
`;
export const ButtonsPanelStyled = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: 8px;
  gap: 16px;

  ${ADAPTIVE.minWidth.tablet} {
    flex-direction: row;
    margin-bottom: 0px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 32px;
  }
`;
export const ItemColumn = styled.div `
  width: 100%;

  ${ADAPTIVE.minWidth.tablet} {
    width: auto;
  }
`;
